import "./Engage.css";
import heroImg from "../assets/engage/hero.png";
import howToImg1 from "../assets/engage/how-to-1.png";
import howToImg2 from "../assets/engage/how-to-2.png";
import howToImg3 from "../assets/engage/how-to-3.png";
import howToImg4 from "../assets/engage/how-to-4.png";
import howPossible1 from "../assets/engage/how-possible-1.png";
import howPossible2 from "../assets/engage/how-possible-2.png";
import joinStep1 from "../assets/engage/join-step-1.png";
import joinStep2 from "../assets/engage/join-step-2.png";
import joinStep3 from "../assets/engage/join-step-3.png";
import joinStep4 from "../assets/engage/join-step-4.png";
import joinStep5 from "../assets/engage/join-step-5.png";
import joinStep6 from "../assets/engage/join-step-6.png";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import $firestore, { $firebaseAuth } from "../services/app/firebase-service";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import BaseIcon from "../components/Base/BaseIcon/BaseIcon";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

interface EngageProps {}

interface FAQPanelProps {
  q: string;
  a: string;
  opener: Function;
  isOpen: boolean;
  key: string;
  index: number;
}

const FAQPanel: React.FC<FAQPanelProps> = (props) => {
  const [FAQPanelRef] = useAutoAnimate<HTMLDivElement>();
  return (
    <article key={props.key} ref={FAQPanelRef}>
      <header onClick={() => props.opener(props.index)}>
        <h3>{props.q}</h3>
        <BaseIcon
          icon={props.isOpen ? faChevronUp : faChevronDown}
          size={"0.875rem"}
        />
      </header>
      {props.isOpen && <p>{props.a}</p>}
    </article>
  );
};

const Engage: React.FC<EngageProps> = (props) => {
  type ContestData = {
    contestInfos: {
      nextDraw: string;
      lastDraw: string;
      lastDrawVODUrl: string;
      lastWinnerId: string;
    };
    mainPrize: {
      name: string;
      value: number;
      pictureUrl: string;
    };
    secondaryPrizes: {
      range: string;
      prize: string;
    }[];
  };
  const [authState, setAuthState] = useState("UNDEFINED");
  const [contestData, setContestData] = useState({
    contestInfos: {
      nextDraw: "",
      lastDraw: "",
      lastDrawVODUrl: "",
      lastWinnerId: "",
    },
    mainPrize: {
      name: "",
      value: 0,
      pictureUrl: "",
    },
    secondaryPrizes: [],
  } as ContestData);

  const [openedFAQPanelsIndexes, setOpenedFAQPanelsIndexes] = useState(
    [] as number[]
  );

  useEffect(() => {
    onAuthStateChanged($firebaseAuth, (user) => {
      if (user && authState === "UNDEFINED") {
        setAuthState("AUTH");
      } else if (!user && authState === "UNDEFINED") {
        setAuthState("ANON");
      }
    });
  }, [authState]);

  useEffect(() => {
    if (!contestData?.mainPrize?.name) {
      getDoc(doc($firestore, "__data", "current_contest")).then((doc) => {
        if (doc.data()) {
          setContestData({
            contestInfos: {
              nextDraw: doc.data()?.contestInfos.nextDraw,
              lastDraw: doc.data()?.contestInfos.lastDraw,
              lastDrawVODUrl: doc.data()?.contestInfos.lastDrawVODUrl,
              lastWinnerId: doc.data()?.contestInfos.lastWinnerId,
            },
            mainPrize: {
              name: doc.data()?.mainPrize.name,
              value: doc.data()?.mainPrize.value,
              pictureUrl: doc.data()?.mainPrize.pictureUrl,
            },
            secondaryPrizes: [...doc.data()?.secondaryPrizes],
          });
        }
      });
    }
  }, [contestData?.mainPrize?.name]);

  const toggleFAQPanelHandler = (index: number) => {
    const newOpenedFAQPanelsList = [] as number[];
    openedFAQPanelsIndexes.map((panelIndex) => {
      if (panelIndex !== index) {
        newOpenedFAQPanelsList.push(panelIndex);
      }
      return panelIndex;
    });
    if (openedFAQPanelsIndexes.includes(index)) {
      return setOpenedFAQPanelsIndexes([...newOpenedFAQPanelsList]);
    }
    return setOpenedFAQPanelsIndexes([...newOpenedFAQPanelsList, index]);
  };

  const navigate = useNavigate();

  return (
    <main className="engage-page">
      <section className="ended">
        <div>
          <span>
            Le concours est terminé ! Félicitations à #Nolann qui l'a remporté
            et s'amuse actuellement avec sa Nintendo Switch !
          </span>
        </div>
      </section>
      <section className="hero">
        <article>
          <h1>
            Gagne des cadeaux avec DevClub <span>Engage</span> !
          </h1>
          <p>
            Trouve les <strong>codes secrets</strong> dans les vidéos du
            DevClub, récupère un <strong>max de tickets</strong> et tente ta
            chance pour gagner <strong>le gros lot</strong> ! <br /> <br />
            En plus c’est <strong>fun</strong> et <strong>gratuit</strong> !
          </p>
          <div className="button-group">
            <button
              onClick={() => {
                document.querySelector("#faq-and-rules")?.scrollIntoView();
              }}
            >
              Règlement
            </button>
            <button
              onClick={() =>
                navigate(
                  authState === "AUTH" ? "/my-account#engage" : "/signup"
                )
              }
            >
              Rejoindre
            </button>
          </div>
        </article>
        <aside>
          <img src={heroImg} alt="devclub-engage-illustration" />
        </aside>
      </section>
      <section className="how-it-works">
        <h2>Comment ça marche ?</h2>
        <div>
          {[
            {
              strongText: "Trouve les codes secrets",
              text: "dissimulés dans les vidéos YouTube et valide les dans ton profile DevClub !",
              img: howToImg1,
              imgAlt: "devclub-engage-how-to-1",
            },
            {
              strongText: "Accumule des tickets",
              text: "tous les jours en te connectant sur ton profil DevClub.",
              img: howToImg2,
              imgAlt: "devclub-engage-how-to-2",
            },
            {
              strongText: "Participe au prochain tirage",
              text: "et augmente tes chances de gagner le gros lot en fonction de ton nombre de tickets.",
              img: howToImg3,
              imgAlt: "devclub-engage-how-to-3",
            },
            {
              strongText: "Gagne de l’expérience",
              text: "au fil du temps et remonte dans le classement des membres du DevClub !",
              img: howToImg4,
              imgAlt: "devclub-engage-how-to-4",
            },
          ].map((item, index) => (
            <article key={`how-to-${index}`}>
              <aside>
                <img src={item.img} alt={item.imgAlt} />
              </aside>
              <p>
                <strong>{item.strongText + " "}</strong>
                {item.text}
              </p>
            </article>
          ))}
        </div>
      </section>
      {/* <section className="what-to-win">
        <h2>Qu'est-ce qu'on peut gagner ?</h2>
        <div className="prizes">
          <article>
            <header
              className={classNames({
                skeleton: !contestData.mainPrize?.name,
              })}
            >
              <div style={{ opacity: contestData.mainPrize.name ? 1 : 0 }}>
                <h4>{contestData.mainPrize?.name || ""}</h4>
                <span>
                  Valeur : {contestData.mainPrize?.value.toString() || ""}€
                </span>
              </div>
              <aside>
                {contestData.mainPrize?.pictureUrl && (
                  <img
                    src={contestData.mainPrize?.pictureUrl}
                    alt="devclub-engage-first-prize"
                  />
                )}
              </aside>
            </header>
            <footer>
              <h3>1er prix du prochain tirage</h3>
              <h5>{contestData.contestInfos?.nextDraw || ""}</h5>
            </footer>
          </article>
          <article>
            <header>
              {!contestData.contestInfos?.lastWinnerId ? (
                <div
                  className="contest-winner-placeholder skeleton"
                  style={{ height: "216px", width: "100%" }}
                />
              ) : (
                <MemberCard
                  firstname="Geoffrey"
                  lastname="Champion"
                  contestantExperience={1012}
                  geoId="21"
                  githubId=""
                  linkedinId=""
                  mainSkill=""
                  portfolioUrl=""
                  profilePictureUrl=""
                  rewardsIds={[]}
                  skills={[]}
                  startingYear={0}
                  status="OBSERVER"
                  subSkills={[]}
                  username=""
                />
              )}
            </header>
            <footer>
              <h3>Grand gagnant du dernier tirage</h3>
              <h5>
                {contestData.contestInfos?.lastDraw || ""}
                {contestData.contestInfos?.lastDrawVODUrl && (
                  <a href={contestData.contestInfos?.lastDrawVODUrl || ""}>
                    - Revoir
                  </a>
                )}
              </h5>
            </footer>
          </article>
        </div>
        {contestData.secondaryPrizes?.length && (
          <article>
            <h4>Les lots de consolation</h4>
            <ul>
              {contestData.secondaryPrizes.map((secondaryPrize) => {
                return (
                  <li key={secondaryPrize.range}>
                    <strong>{secondaryPrize.range} : </strong>{" "}
                    {secondaryPrize.prize}
                  </li>
                );
              })}
            </ul>
          </article>
        )}
      </section> */}
      <section className="how-possible">
        <h2>C'est possible grâce à notre communauté !</h2>
        <div>
          <article>
            <h3>Parce que la chaîne YouTube rapporte un peu d'argent.</h3>
            <p>
              Et, qu'au lieu de prendre des vacances à Dubaï, j'ai décidé de
              réinvestir la totalité des revenus générés.
              <br /> <br />
              D'abord et en grande partie dans DevClub Engage mais aussi dans la
              maintenance et l'hébergement des applications que je partage avec
              vous.
              <br /> <br />
              Ainsi, la prochaine fois que vous verrez une pub sur la chaîne,
              rappelez-vous que je me prive de nombreux kebabs 🥙 !
            </p>
          </article>
          <aside>
            <img src={howPossible1} alt="devclub-engage-how-possible-1" />
          </aside>
        </div>
        <div>
          <aside>
            <img src={howPossible2} alt="devclub-engage-illustration" />
          </aside>
          <article>
            <h3>La motivation de la communauté DevClub.</h3>
            <p>
              Si j’ai eu la motivation ces derniers mois de développer
              l’algorithme nécessaire à DevClub Engage c’est avant tout grâce à
              vos soutiens !
              <br /> <br />
              Il est donc juste selon moi de vous faire profiter du succès de la
              chaîne YouTube car, sans vous, sans vos commentaires, sans vos
              likes, sans vos partages, faire des vidéos aurait beaucoup moins
              de saveur.
              <br /> <br />
              Et puis autant faire quelque chose d’un peu fun et pas simplement
              des concours sur Instagram ! J’espère que vous apprécierez
              participer à DevClub Engage car j’ai mis beaucoup de coeur à
              l’ouvrage !
            </p>
          </article>
        </div>
      </section>
      <section className="how-to-join">
        <h2>Comment participer à DevClub Engage ?</h2>
        <div>
          <article>
            <h3>
              <span>1</span>Avoir un profil sur DevClub
            </h3>
            <p>
              Ça parait évident, mais je sais qu’il y en a au fond de la classe
              qui ne suivent pas...première étape : avoir un profil sur devclub.
              <br />
              <br />
              Et quand je parle d’un profil, ce n’est pas celui d’un fantôme !
              <br />
              <br />
              Il faut remplir un minimum d’informations :<br />
              <strong>Nom*, Prénom*, Pseudo et photo de profil !</strong>
              <br />
              <br />
              <small>
                *Rien ne t’empêches d’utiliser des noms et prénoms fictifs dans
                ton profil...
              </small>
            </p>
          </article>
          <aside>
            <img src={joinStep1} alt="devclub-engage-illustration" />
          </aside>
        </div>
        <div>
          <article>
            <h3>
              <span>2</span>Remplir le formulaire
            </h3>
            <p>
              Sur la page de ton compte Dev Club, tu peux retrouver une section
              dédiée à Engage. Pour participer au programme Engage il te suffit
              de compléter l’inscription !
              <br />
              <br />
              <strong>
                Attention, ce coup-ci tes informations doivent être réelles et
                ne pourront plus être modifiées après inscription !
              </strong>
              <br />
              <br />
              C’est nécessaire, déjà pour éviter les robots, mais aussi si tu
              remportes un lot, il faudra bien que je sache où l’envoyer ! Bien
              entendu, toutes les informations que tu renseignes ici sont
              masquées et invisibles par les autres membres du club.
              <br />
              <br />
              Et pas d’inquiétudes,{" "}
              <strong>elles ne serviront que dans le cadre d’Engage !</strong>
              <br />
              <br />
              Ton numéro de téléphone doit être le bon car tu seras contacté sur
              celui-ci dans le cas où tu remportes le gros lot.
            </p>
          </article>
          <aside>
            <img src={joinStep2} alt="devclub-engage-illustration" />
          </aside>
        </div>
        <div>
          <article>
            <h3>
              <span>3</span>Trouve les codes secrets
            </h3>
            <p>
              Dès la sortie d'une nouvelle vidéo, essaie de trouver le code
              secret qu'elle contient ! Attention, toutes les vidéos de la
              chaîne n'en contiennent pas.
              <br />
              <br />
              Un code secret est composé de <strong>3 à 5 caractères</strong>,
              dévoilés un par un tout au long d'une vidéo. Quand tu valides un
              code secret, n'oublie pas de respecter l'ordre d'apparition des
              caractères !
              <br />
              <br />A tout moment dans la section Engage de ton profil, tu peux
              connaître le nombre de codes secrets que tu as trouvés, et combien
              il t'en reste à découvrir !
            </p>
          </article>
          <aside>
            <img src={joinStep3} alt="devclub-engage-illustration" />
          </aside>
        </div>
        <div>
          <article>
            <h3>
              <span>4</span>Empoche des tickets !
            </h3>
            <p>
              Les tickets sont très importants ! Plus tu en possèdes pour le
              prochain tirage, plus tu as de chances de gagner le gros lot !
              <br />
              <br />
              Chaque jour, connecte-toi sur DevClub et, dans la section Engage
              de ton profil, récupère les tickets du jour !
              <br />
              <br />
              Le nombre de tickets que tu peux récupérer{" "}
              <strong>
                dépend du succès des vidéos pour lesquelles tu as trouvé un code
                secret.{" "}
              </strong>
              <br />
              <br />
              Mais l'algorithme de calcul exact reste cependant secret...
              <br />
              <br />
              <strong>Attention</strong> si tu ne récupères pas les tickets du
              jour en cours, ils sont perdus ! Pense alors à te connecter tous
              les jours pour récupérer tes tickets.
              <br />
              <br />
              Après chaque tirage tes tickets seront remis à zéro, mais tu
              conserveras cependant des points d’expériences qui détermineront
              ta place dans l’annuaire des membres du DevClub. Plus tu
              participes, plus tu montes dans le classement !
              <br />
              <br />
              <small>
                Astuce : Trouver un code secret le jour de la parution d'une
                vidéo est le meilleur moyen de récupérer plein de tickets le
                lendemain...
              </small>
            </p>
          </article>
          <aside>
            <img src={joinStep4} alt="devclub-engage-illustration" />
          </aside>
        </div>
        <div>
          <article>
            <h3>
              <span>5</span>Regarde le tirage au sort !
            </h3>
            <p>
              Le tirage du ou des lots se fera, soit en live sur YouTube/Twitch,
              soit dans une vidéo dédiée. Mais pas d’inquiétudes, si tu gagnes
              je te contacterai.
              <br />
              <br />
              Si tu remportes un lot, tu seras contacté la semaine suivante sur
              le <strong>numéro de téléphone</strong> que tu as renseigné dans
              le formulaire de participation. Alors attention à bien rester
              vigilant et décrocher ton téléphone.
              <br />
              <br />
              Le lot sera envoyé <strong>à l’adresse</strong> que tu as
              renseignée au moment de ton inscription. Il ne sera pas possible
              de demander une modification et malheureusement, si ton numéro de
              téléphone ou ton adresse posent problème, une autre personne sera
              tirée au sort.
              <br />
              <br />
              Une fois le lot reçu, tu pourras nous faire une petite vidéo ou un
              petit témoignage écrit pour nous dire si tu l’apprécies !
              <br />
              <br />
              <small>
                Note : Après un tirage, la légitimité du gagnant est
                manuellement étudiée, alors pas de bétises...
              </small>
            </p>
          </article>
          <aside>
            <img src={joinStep5} alt="devclub-engage-illustration" />
          </aside>
        </div>
        <div>
          <article>
            <h3>
              <span>6</span>Accumule de l'expérience
            </h3>
            <p>
              Même si tu ne conserves pas tes tickets après chaque tirage, tu
              accumules cependant <strong>des points d'expérience !</strong>
              <br />
              <br />
              Dans l'annuaire des membres, ce sont ces points qui peuvent te
              permettre d'arriver jusqu'à la première page.
              <br />
              <br />
              Alors soit assidu pour atteindre{" "}
              <strong>la première place !</strong> Enfin...la deuxième place
              puisque je triche un peu en étant premier 😎 !
            </p>
          </article>
          <aside>
            <img src={joinStep6} alt="devclub-engage-illustration" />
          </aside>
        </div>
      </section>
      <section className="faq-and-rules" id="faq-and-rules">
        <h2>FAQ / Règlement</h2>
        <div>
          {[
            {
              q: "Puis-je rejoindre Engage même si je n'habite pas en France Métropolitaine ?",
              a: "Oui, le programme Engage est ouvert à tous, dans le monde entier. Cependant, le tirage au sort des lots physiques nécessitant un envoi postal est, lui, réservé aux résidents de France Métropolitaine. Si tu es tiré au sort et remporte un lot physique sans être en France Métropolitaine, le tirage sera invalidé pour ce lot et relancé. Tu obtiendras cependant, si possible, un lot de consolation immatériel sur une application du DevClub. Même sans gros lot physique à gagner, tu peux toujours participer pour monter dans le classement.",
            },
            {
              q: "Comment sont utilisées les informations personnelles de mon inscription ?",
              a: "Les informations personnelles demandées ont deux objectifs. D'abord permettre de te contacter et t'envoyer un lot si tu es tiré au sort. Mais aussi éviter au maximum les comptes doublons et les tricheurs. C'est pour cette raison qu'une fois inscrit, tu ne peux plus modifier ces informations. Au-delà de ces deux raisons, tes informations personnelles ne seront jamais cédées, vendues ou exploitées par un tiers. Tu peux demander à tout moment sur Discord ta désinscription et ainsi faire supprimer tes données personnelles.",
            },
            {
              q: "Pourquoi dois-je accepter de recevoir la newsletter du DevClub pour m'inscrire ?",
              a: "J'ai besoin de ton consentement avant de t'envoyer des emails. Engage est l'occasion pour moi de recueillir ton consentement. La newsletter n'existe pas encore mais elle pourra contenir l'actualité du DevClub ou te tenir informé(e) de certaines opérations que je compte mettre en place (publication de formations, vidéos etc.). Dans tous les cas, cette future newsletter n'aura pas une fréquence de parution dérangeante et tu pourras te désinscrire quand tu le souhaites.",
            },
            {
              q: "À quelle fréquence se produisent les tirages ?",
              a: "En moyenne, un tirage est effectué tous les mois. Mais cette fréquence est indicative et sera modulée en fonction de plusieurs éléments. Par exemple, pour augmenter la valeur du premier prix, il pourra être nécessaire de patienter un peu plus, Engage étant auto-financé. Il est possible aussi que les tirages soient mis en pause, par exemple pendant les vacances. La date, d'abord indicative, puis précisée, du prochain tirage sera visible dans le panneau Engage du profil ou sur cette page.",
            },
            {
              q: "Pendant combien de temps devrait durer le programme Engage ?",
              a: "Aussi longtemps que possible, mais l'objectif est au minimum de perdurer sur toute l'année 2023 concernant les tirages.",
            },
            {
              q: "Quels sont les lots prévus en 2023 ?",
              a: "La valeur des lots dépendra toujours de ce que la chaîne YouTube génère comme financement via la publicité. Il est donc difficile d'établir à l'avance des lots. Mais on peut imaginer des AirPods, des claviers mécaniques, des souris gaming etc. et parfois des plus gros lot si possible.",
            },
            {
              q: "Si je me trompe dans mes informations d'inscription, que faire ?",
              a: "Après s'être inscrit, il est impossible de modifier ces informations. Cependant et au prix d'une remise à zéro, tu peux demander une désinscription, puis te réinscrire.",
            },
            {
              q: "Est-ce que YouTube est lié à Engage ?",
              a: "Ni YouTube, ni Google ne sont liés d'une manière ou d'une autre à Engage.",
            },
            {
              q: "Est-ce que liker, commenter, partager, regarder une vidéo augmente mes chances de gagner ?",
              a: "Non, t'engager dans une vidéo ne produit aucun effet direct sur tes chances de gagner. Tu n'es absolument pas obligé de liker, commenter, partager et regarder les vidéos, Engage fonctionnant en indépendance de YouTube. Tu peux bien entendu le faire si tu en as envie, ça aide la chaîne.",
            },
            {
              q: "Comment sont calculés chaque jour les tickets que je peux gagner ?",
              a: 'Chaque code secret que tu trouves est lié à une vidéo. Tous les jours, et pour chaque vidéo, un "score" est déterminé. Ainsi, le lendemain, et pour chaque vidéo dont tu as trouvé le code secret, un certain nombre de tickets sont disponibles. Le calcul du score restera "secret", mais plus une vidéo a du succès, plus le score, chaque jour, sera élevé. Comme une vidéo a généralement plus de succès dans les premiers jours, plus tôt tu trouveras son code, plus tu pourras récolter de tickets.',
            },
            {
              q: "Est-ce que je peux t'aider d'une manière ou d'une autre (code, etc.)?",
              a: "C'est gentil, mais je n'ai pas besoin d'aide ! Le meilleur moyen si tu veux m'aider, c'est de t'abonner, de partager les vidéos, de les commenter et de les liker. ",
            },
            {
              q: "Nous sommes une entreprise, c'est possible de t'aider à financer/offrir des dotations ?",
              a: "Avec plaisir ! Vous pouvez me contacter dans ce cas via l'adresse email de contact disponible sur la chaîne YouTube ou directement sur Discord.",
            },
            {
              q: "Article 1 : Organisateur des jeux concours.",
              a: "L'organisateur officiel est la société SUDOCOOL - 6 RUE D'ARMAILLE - 75017 PARIS - SIREN : 908928963. (Présidée par Hugo Taschet)",
            },
            {
              q: "Article 2 : Durée du jeu.",
              a: "Le programme DevClub Engage est un ensemble de jeux concours par tirage au sort, sans obligations d'achat. Chaque tirage est effectué à une période/date déterminée en amont et visible sur cette même page. Les tickets servant de pondération au tirage au sort sont accumulés dans l'intervalle séparant deux tirages et sont réinitialisés après chacun d'entre eux.",
            },
            {
              q: "Article 3 : Acceptation sans résèrves des règles.",
              a: "En s'inscrivant à DevClub Engage, les participants adhèrent sans aucune résèrve à toutes les règles édictées. Engage n'offre aucune garantie de lancement d'un nouveau tirage et ne s'engage que pour le jeu concours en cours.",
            },
            {
              q: "Article 4 : Conditions de participation.",
              a: "Les jeux-concours sont ouverts et gratuits pour toute personne physique âgée de plus de 13 ans résidant en France et à l'étranger. Sont exclues toutes personnes liées directement à la société SUDOCOOL ou familière de son président Hugo Taschet. Tout participant mineur doit obtenir l'autorisation préalable de ses deux parents ou de son tuteur légal pour participer. Les lots physiques mis en jeu et qui nécessitent d'être expédiés par voie postale sont cependant réservés aux résidents de France Métropolitaine ayant renseigné une adresse en France Métropolitaine.",
            },
            {
              q: "Article 5 : Limitation de participation.",
              a: "Une seule participation par foyer, personne, propriétaire de la ligne téléphonique et compte DevClub est autorisée. Toute personne essayant de contourner cette règle sera bannie du programme et dans le cas où elle aurait gagné un lot, se verra dans l'obligation de le restituer s'il a déjà été envoyé, et ne pourra en bénéficier s'il n'a pas déjà été envoyé.",
            },
            {
              q: "Article 6 : Contournement des systèmes de protection.",
              a: "Toute personne ou entité qui tenterait de contourner les systèmes mis en place pour garantir l'intégrité des jeux-concours ou de la plateforme devclub.fr s'expose à des poursuites judiciaires.",
            },
            {
              q: "Article 7 : Nullité de la participation.",
              a: "La société SUDOCOOL et son président Hugo Taschet se résèrvent le droit intégral, sans devoir justifier d'une décision, de rendre nulle une participation, avant le tirage d'un lot concours. Après tirage d'un lot, le droit est conservé mais sera justifié expressement pour irrégularité de la participation.",
            },
            {
              q: "Article 8 : Réglementation en vigueur.",
              a: "Les jeux-concours organisés par la société SUDOCOOL sont soumis à la réglementation de la loi Française applicable aux jeux et concours.",
            },
            {
              q: "Article 9 : Indépendance des jeux-concours.",
              a: "Regroupés sous une bannière commune nommée Engage, chaque jeu-concours est indépendant et ne garantie pas le déroulement des autres.",
            },
            {
              q: "Article 10 : Principe des jeux-concours.",
              a: "Les participants, après s'être inscrits via un formulaire, doivent trouver au sein des vidéos de la chaîne YouTube DevClub, des codes secrets cachés. Après avoir renseigné ces codes secrets dans leur profil, ils peuvent, dès le lendemain, récolter chaque jour, un nombre de ticket imprévisible (l'algorithme de score étant secret) pour chaque vidéo dont le code a été trouvé. A date ou période déterminée, un tirage au sort, pondéré par le nombre de tickets de chaque participant est effectué, soit en direct, soit en différé sur la chaîne YouTube du DevClub ou tout autre moyen de communication. Après avoir été tiré au sort, le gagnant du lot principal (physique) est contacté sur son numéro de téléphone (5 tentatives) dans la semaine qui suit. Le lot est ensuite envoyé dans un délai pouvant aller jusqu'à 8 semaines. Les autres participants conservent sous la forme de points d'expérience leurs tickets et peuvent ainsi remonter dans le classement des membres. Les gagnants ayant remportés des lots non-physiques sont contactés via leur adresse email.",
            },
            {
              q: "Article 11 : Cas de nullité et nécessité de re-tirage.",
              a: "La désignation d'un gagnant via tirage au sort peut-être annulée dans les cas suivants : si le gagnant ne répond pas au téléphone dans la semaine qui suit après 5 tentatives, si le gagnant d'un lot physique ne réside pas en France Métropolitaine, si plusieurs éléments concordent pour suspecter une fraude de participation. Dans le cas où le tirage du lot est rendu caduque, soit l'ensemble du tirage est de nouveau effectué, soit la personne suivante dans la liste est choisie. Ce retirage ou cette redésignation peuvent être effectués en direct ou en différé, de manière publique ou privée.",
            },
            {
              q: "Article 12 : Dotation et remise de dotation.",
              a: "Chaque lot est prévu en avance. Il est impossible de substituer un lot à un autre ou de modifier la nature d'un lot. Le gagnant d'un lot physique est contacté la semaine suviante. 5 tentatives sont effectuées pour le joindre. Sans réponse de sa part, sa participation est rendue caduque et le lot remis en jeu selon les modalités de retirage. Les lots non-physiques seront remis par email, sous forme de code ou tout autre moyen. Les lots sont transmis au maximum 8 semaines après avoir été remportés.",
            },
            {
              q: "Article 13 : Gratuité de la participation.",
              a: "Les jeux-concours sont gratuits, aucun frais ou remboursement ne pourra être demandé à la société SUDOCOOL, pour quelque motif que ce soit. Toute utilisation d'un abonnement internet/téléphonique pour participer est destiné avant tout à profiter de la plateforme devclub.fr sans qu'il n'y ait besoin d'y rattacher Engage. Ainsi aucun frais ou remboursement ne pourra être demandé sur cette base, ni sur aucun autre élément.",
            },
            {
              q: "Article 14 : Utilisation des données personnelles.",
              a: "Les données personnelles transmises par les participants sont privées et ne seront jamais cédées à des tiers. Les participants bénéficient d'un droit de rectification, soumis à la remise à zéro de leur participation, mais aussi de suppression en contactant l'organisateur via la plateforme Discord. Les gagnants d'un tirage pourront être affichés sur cette page, mais seulement via les informations publiques renseignées dans leur profil DevClub.",
            },
            {
              q: "Article 15 : Responsabilité.",
              a: "L'Organisateur ne saurait voir sa responsabilité engagée du fait de l’impossibilité de contacter chaque gagnant, de même qu’en cas de perte, de vol ou de dégradation du lot lors de son acheminement. L’Organisateur ne pourra non plus être responsable des erreurs éventuelles portant sur le nom, l’adresse et/ou les coordonnées communiquées par les personnes ayant participé au jeu-concours. Par ailleurs, l’Organisateur du jeu concours décline toute responsabilité pour tous les incidents qui pourraient survenir lors de la jouissance du prix attribué et/ou fait de son utilisation et/ou de ses conséquences, notamment de la jouissance d’un lot par un mineur, qui reste sous l’entière et totale responsabilité d’une personne ayant l’autorité parentale. L’Organisateur se réserve le droit, si les circonstances l’exigent, d’écourter, de prolonger, de modifier, d’interrompre, de différer ou d’annuler le jeu-concours, sans que sa responsabilité ne soit engagée. Toutefois, toute modification fera l’objet d’un avenant qui sera mis en ligne sur devclub.fr (cette même page). L’Organisateur se dégage de toute responsabilité en cas de dysfonctionnement empêchant l’accès et/ ou le bon déroulement du jeu-concours notamment dû à des actes de malveillances externes. L’utilisation de robots ou de tous autres procédés similaires permettant de participer au jeu-concours de façon mécanique ou autre est proscrite, la violation de cette règle entraînant l’élimination définitive de son réalisateur et/ ou utilisateur. L’Organisateur pourra annuler tout ou partie du jeu-concours s’il apparaît que des fraudes sont intervenues sous quelque forme que ce soit, notamment de manière informatique dans le cadre de la participation au jeu-concours ou de la détermination des gagnants. Il se réserve, dans cette hypothèse, le droit de ne pas attribuer les dotations aux fraudeurs et/ ou de poursuivre devant les juridictions compétentes les auteurs de ces fraudes.",
            },
          ].map((item, index) => {
            return (
              <FAQPanel
                q={item.q}
                a={item.a}
                index={index}
                isOpen={openedFAQPanelsIndexes.includes(index)}
                key={"q-a-" + index}
                opener={toggleFAQPanelHandler}
              />
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Engage;
